import { PLATFORMS } from '@constants';

export const trustPilot = {
  templateId: '53aa8807dec7e10d38f59f32',
  height: '98px',
  width: '100%',
  theme: 'dark',
  [PLATFORMS.SPAIN]: {
    businessId: '57cd2db50000ff00059450e6',
    dataQa: 'trustpilotEsCta',
    locale: 'es-ES',
  },
  [PLATFORMS.ITALY]: {
    businessId: '570421200000ff00058b1b7c',
    dataQa: 'trustpilotITCta',
    locale: 'it-IT',
  },
};
